<template>
  <div class="conflict-modal" :class="{ warn }">
    <div class="content">
      <span class="title" v-if="warn">Daten-Synchronisierung</span>
      <span class="title" v-else>Daten-Versionen</span>
      <p v-if="warn">
        Ihre lokalen Daten unterscheiden sich von der aktuellen Server-Version.<br/>
        Bitte wählen Sie den Stand aus, der übernommen werden soll:
      </p>
      <p v-else>Bitte wählen den Stand aus, den Sie gerne übernehmen möchten:</p>
      <Select
        fill
        :options="computedVersions"
        :value.sync="ivalue"
        @input="handleInput"
      />
    </div>
    <div v-if="actionButtons" class="actions">
      <Button
          small
          v-for="action in actionButtons"
          :key="action.key"
          :icon="action.icon"
          :class="action.class"
          :icon-only="action.iconOnly"
          :disabled="action.disabled"
          @click="handleActionClick(action.value)">
        {{ action.label }}
      </Button>
    </div>
  </div>
</template>

<script>
  import Button from '@/components/ui/inputs/Button';
  import InquiryDefinitionFunctions from '@/components/inquiry/InquiryDefinitionFunctions';
  import Select from '@/components/ui/inputs/Select';
  import { Store } from '@/store';

  const svgIcon = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.8368 14.0706L13.8368 14.0706L13.8345 14.0733C13.3867 14.5918 12.7699 14.8396 11.9429 14.8654H11.9429H11.9428H11.9428H11.9428H11.9427H11.9427H11.9426H11.9426H11.9425H11.9425H11.9424H11.9424H11.9423H11.9423H11.9422H11.9422H11.9422H11.9421H11.9421H11.942H11.942H11.9419H11.9419H11.9418H11.9418H11.9417H11.9417H11.9416H11.9415H11.9415H11.9414H11.9414H11.9413H11.9413H11.9412H11.9412H11.9411H11.9411H11.941H11.9409H11.9409H11.9408H11.9408H11.9407H11.9407H11.9406H11.9405H11.9405H11.9404H11.9404H11.9403H11.9402H11.9402H11.9401H11.9401H11.94H11.9399H11.9399H11.9398H11.9397H11.9397H11.9396H11.9396H11.9395H11.9394H11.9394H11.9393H11.9392H11.9392H11.9391H11.939H11.9389H11.9389H11.9388H11.9387H11.9387H11.9386H11.9385H11.9385H11.9384H11.9383H11.9382H11.9382H11.9381H11.938H11.9379H11.9379H11.9378H11.9377H11.9376H11.9376H11.9375H11.9374H11.9373H11.9373H11.9372H11.9371H11.937H11.9369H11.9369H11.9368H11.9367H11.9366H11.9365H11.9365H11.9364H11.9363H11.9362H11.9361H11.936H11.9359H11.9359H11.9358H11.9357H11.9356H11.9355H11.9354H11.9353H11.9352H11.9352H11.9351H11.935H11.9349H11.9348H11.9347H11.9346H11.9345H11.9344H11.9343H11.9342H11.9341H11.934H11.934H11.9339H11.9338H11.9337H11.9336H11.9335H11.9334H11.9333H11.9332H11.9331H11.933H11.9329H11.9328H11.9327H11.9326H11.9325H11.9324H11.9323H11.9322H11.932H11.9319H11.9318H11.9317H11.9316H11.9315H11.9314H11.9313H11.9312H11.9311H11.931H11.9309H11.9307H11.9306H11.9305H11.9304H11.9303H11.9302H11.9301H11.93H11.9298H11.9297H11.9296H11.9295H11.9294H11.9293H11.9291H11.929H11.9289H11.9288H11.9287H11.9285H11.9284H11.9283H11.9282H11.9281H11.9279H11.9278H11.9277H11.9276H11.9274H11.9273H11.9272H11.9271H11.9269H11.9268H11.9267H11.9265H11.9264H11.9263H11.9261H11.926H11.9259H11.9258H11.9256H11.9255H11.9253H11.9252H11.9251H11.9249H11.9248H11.9247H11.9245H11.9244H11.9243H11.9241H11.924H11.9238H11.9237H11.9235H11.9234H11.9233H11.9231H11.923H11.9228H11.9227H11.9225H11.9224H11.9222H11.9221H11.9219H11.9218H11.9216H11.9215H11.9213H11.9212H11.921H11.9209H11.9207H11.9206H11.9204H11.9203H11.9201H11.9201H11.9201H11.9201H11.9201H11.9201H11.9201H11.9201H11.9201H11.92H11.92H11.92H11.92H11.92H11.92H11.92H11.92H11.92H11.92H11.9199H11.9199H11.9199H11.9199H11.9199H11.9199H11.9199H11.9199H11.9199H11.9198H11.9198H11.9198H11.9198H11.9198H11.9198H11.9198H11.9198H11.9198H11.9198H11.9198H11.9197H11.9197H11.9197H11.9197H11.9197H11.9197H11.9197H11.9197H11.9197H11.9197H11.9197H11.9196H11.9196H11.9196H11.9196H11.9196H11.9196H11.9196H11.9196H11.9195H11.9195H11.9195H11.9195H11.9195H11.9195H11.9195H11.9195H11.9194H11.9194H11.9194H11.9194H11.9194H11.9194H11.9194H11.9194H11.9193H11.9193H11.9193H11.9193H11.9193H11.9193H11.9192H11.9192H11.9192H11.9192H11.9192H11.9192H11.9191H11.9191H11.9191H11.9191H11.9191H11.9191H11.919H11.919H11.919H11.919H11.919H11.9189H11.9189H11.9189H11.9189H11.9189H11.9188H11.9188H11.9188H11.9188H11.9188H11.9187H11.9187H11.9187H11.9187H11.9186H11.9186H11.9186H11.9186H11.9186H11.9185H11.9185H11.9185H11.9185H11.9184H11.9184H11.9184H11.9184H11.9183H11.9183H11.9183H11.9183H11.9182H11.9182H11.9182H11.9181H11.9181H11.9181H11.9181H11.918H11.918H11.918H11.9179H11.9179H11.9179H11.9179H11.9178H11.9178H11.9178H11.9177H11.9177H11.9177H11.9176H11.9176H11.9176H11.9175H11.9175H11.9175H11.9174H11.9174H11.9174H11.9173H11.9173H11.9173H11.9172H11.9172H11.9172H11.9171H11.9171H11.9171H11.917H11.917H11.9169H11.9169H11.9169H11.9168H11.9168H11.9168H11.9167H11.9167H11.9166H11.9166H11.9166H11.9165H11.9165H11.9164H11.9164H11.9163H11.9163H11.9163H11.9162H11.9162H11.9161H11.9161H11.916H11.916H11.9159H11.9159H11.9159H11.9158H11.9158H11.9157H11.9157H11.9156H11.9156H11.9155H11.9155H11.9154H11.9154H11.9153H11.9153H11.9152H11.9152H11.9151H11.9151H11.915H11.915H11.9149H11.9149H11.9148H11.9148H11.9147H11.9147H11.9146H11.9145H11.9145H11.9144H11.9144H11.9143H11.9143H11.9142H11.9142H11.9141H11.914H11.914H11.9139H11.9139H11.9138H11.9137H11.9137H11.9136H11.9136H11.9135H11.9134H11.9134H11.9133H11.9132H11.9132H11.9131H11.9131H11.913H11.9129H11.9129H11.9128H11.9127H11.9127H11.9126H11.9125H11.9125H11.9124H11.9123H11.9123H11.9122H11.9121H11.912H11.912H11.9119H11.9118H11.9118H11.9117H11.9116H11.9115H11.9115H11.9114H11.9113H11.9112H11.9112H11.9111H11.911H11.9109H11.9109H11.9108H11.9107H11.9106H11.9106H11.9105H11.9104H11.9103H11.9102H11.9102H11.9101H11.91H11.9099H11.9098H11.9097H11.9097H11.9096H11.9095H11.9094H11.9093H11.9092H11.9091H11.9091H11.909H11.9089H11.9088H11.9087H11.9086H11.9085H11.9084H11.9084H11.9083H11.9082H11.9081H11.908H11.9079H11.9078H11.9077H11.9076H11.9075H11.9074H11.9073H11.9072H11.9071H11.907H11.9069H11.9068H11.9067H11.9066H11.9065H11.9064H11.9063H11.9062H11.9061H11.906H11.9059H11.9058H11.9057H11.9056H11.9055H11.9054H11.9053H11.9052H11.9051H11.905H11.9049H11.9048H11.9047H11.9046H11.9045H11.9043H11.9042H11.9041H11.904H11.9039H11.9038H11.9037H11.9036H11.9035H11.9033H11.9032H11.9031H11.903H11.9029H11.9028H11.9026H11.9025H11.9024H11.9023H11.9022H11.902H11.9019H11.9018H11.9017H11.9016H11.9014H11.9013H11.9012H11.9011H11.9009H11.9008H11.9007H11.9006H11.9004H11.9003H11.9002H11.9H11.8999H11.8998H11.8997H11.8995H11.8994H11.8993H11.8991H11.899H11.8989H11.8987H11.8986H11.8985H11.8983H11.8982H11.898H11.8979H11.8978H11.8976H11.8975H11.8973H11.8972H11.8971H11.8969H11.8968H11.8966H11.8965H11.8963H11.8962H11.8961H11.8959H11.8958H11.8956H11.8955H11.8953H11.8952H11.895H11.8949H11.8947H11.8946H11.8944H11.8943H11.8941H11.894H11.8938H11.8936H11.8935C11.0765 14.8654 10.4575 14.5963 10.0058 14.0733L10.0058 14.0733L10.0034 14.0706C9.41741 13.4113 9.17829 12.4444 9.09341 11.6054C9.02013 10.8811 9.06413 10.3126 9.07776 10.1364C9.07995 10.108 9.08136 10.0898 9.08136 10.0828V10.0612C9.13328 8.76542 9.61051 7.90476 10.4416 7.45351C11.0265 7.13675 11.6426 7.11095 11.8402 7.11095H11.8404H11.8405H11.8407H11.8409H11.841H11.8412H11.8413H11.8415H11.8416H11.8418H11.842H11.8421H11.8423H11.8424H11.8426H11.8427H11.8429H11.843H11.8432H11.8434H11.8435H11.8437H11.8438H11.844H11.8441H11.8443H11.8444H11.8446H11.8448H11.8449H11.8451H11.8452H11.8454H11.8455H11.8457H11.8458H11.846H11.8462H11.8463H11.8465H11.8466H11.8468H11.8469H11.8471H11.8472H11.8474H11.8475H11.8477H11.8479H11.848H11.8482H11.8483H11.8485H11.8486H11.8488H11.8489H11.8491H11.8492H11.8494H11.8496H11.8497H11.8499H11.85H11.8502H11.8503H11.8505H11.8506H11.8508H11.8509H11.8511H11.8512H11.8514H11.8515H11.8517H11.8519H11.852H11.8522H11.8523H11.8525H11.8526H11.8528H11.8529H11.8531H11.8532H11.8534H11.8535H11.8537H11.8538H11.854H11.8541H11.8543H11.8544H11.8546H11.8547H11.8549H11.855H11.8552H11.8553H11.8555H11.8556H11.8558H11.8559H11.8561H11.8562H11.8564H11.8565H11.8567H11.8568H11.857H11.8571H11.8573H11.8574H11.8576H11.8577H11.8579H11.858H11.8582H11.8583H11.8585H11.8586H11.8588H11.8589H11.8591H11.8592H11.8594H11.8595H11.8596H11.8598H11.8599H11.8601H11.8602H11.8604H11.8605H11.8607H11.8608H11.861H11.8611H11.8612H11.8614H11.8615H11.8617H11.8618H11.862H11.8621H11.8623H11.8624H11.8625H11.8627H11.8628H11.863H11.8631H11.8633H11.8634H11.8635H11.8637H11.8638H11.864H11.8641H11.8642H11.8644H11.8645H11.8647H11.8648H11.8649H11.8651H11.8652H11.8654H11.8655H11.8656H11.8658H11.8659H11.8661H11.8662H11.8663H11.8665H11.8666H11.8668H11.8669H11.867H11.8672H11.8673H11.8674H11.8676H11.8677H11.8678H11.868H11.8681H11.8682H11.8684H11.8685H11.8687H11.8688H11.8689H11.8691H11.8692H11.8693H11.8695H11.8696H11.8697H11.8699H11.87H11.8701H11.8702H11.8704H11.8705H11.8706H11.8708H11.8709H11.871H11.8712H11.8713H11.8714H11.8716H11.8717H11.8718H11.8719H11.8721H11.8722H11.8723H11.8724H11.8726H11.8727H11.8728H11.873H11.8731H11.8732H11.8733H11.8735H11.8736H11.8737H11.8738H11.874H11.8741H11.8742H11.8743H11.8744H11.8746H11.8747H11.8748H11.8749H11.8751H11.8752H11.8753H11.8754H11.8755H11.8757H11.8758H11.8759H11.876H11.8761H11.8763H11.8764H11.8765H11.8766H11.8767H11.8768H11.877H11.8771H11.8772H11.8773H11.8774H11.8775H11.8777H11.8778H11.8779H11.878H11.8781H11.8782H11.8783H11.8785H11.8786H11.8787H11.8788H11.8789H11.879H11.8791H11.8792H11.8793H11.8795H11.8796H11.8797H11.8798H11.8799H11.88H11.8801H11.8802H11.8803H11.8804H11.8805H11.8806H11.8807H11.8809H11.881H11.8811H11.8812H11.8813H11.8814H11.8815H11.8816H11.8817H11.8818H11.8819H11.882H11.8821H11.8822H11.8823H11.8824H11.8825H11.8826H11.8827H11.8828H11.8829H11.883H11.8831H11.8832H11.8833H11.8834H11.8835H11.8836H11.8837H11.8838H11.8839H11.8839H11.884H11.8841H11.8842H11.8843H11.8844H11.8845H11.8846H11.8847H11.8848H11.8849H11.885H11.885H11.8851H11.8852H11.8853H11.8854H11.8855H11.8856H11.8857H11.8857H11.8858H11.8859H11.886H11.8861H11.8862H11.8863H11.8863H11.8864H11.8865H11.8866H11.8867H11.8867H11.8868H11.8869H11.887H11.8871H11.8871H11.8872H11.8873H11.8874H11.8875H11.8875H11.8876H11.8877H11.8878H11.8878H11.8879H11.888H11.8881H11.8881H11.8882H11.8883H11.8884H11.8884H11.8885H11.8886H11.8886H11.8887H11.8888H11.8888H11.8889H11.889H11.8891H11.8891H11.8892H11.8893H11.8893H11.8894H11.8894H11.8895H11.8896H11.8896H11.8897H11.8898H11.8898H11.8899H11.8899H11.89H11.8901H11.8901H11.8902H11.8902H11.8903H11.8904H11.8904H11.8905H11.8905H11.8906H11.8906H11.8907H11.8908H11.8908H11.8909H11.8909H11.891H11.891H11.8911H11.8911H11.8912H11.8912H11.8913H11.8913H11.8914H11.8914H11.8915H11.8915H11.8916H11.8916H11.8916H11.8917H11.8917H11.8918H11.8918H11.8919H11.8919H11.8919H11.892H11.892H11.8921H11.8921H11.8921H11.8922H11.8922H11.8923H11.8923H11.8923H11.8924H11.8924H11.8924H11.8925H11.8925H11.8925H11.8926H11.8926H11.8926H11.8927H11.8927H11.8927H11.8928H11.8928H11.8928H11.8928H11.8929H11.8929H11.8929H11.8929H11.893H11.893H11.893H11.893H11.8931H11.8931H11.8931H11.8931H11.8931H11.8932H11.8932H11.8932H11.8932H11.8932H11.8933H11.8933H11.8933H11.8933H11.8933H11.8933H11.8933H11.8934H11.8934H11.8934H11.8934H11.8934H11.8934H11.8934H11.8934H11.8934H11.8934H11.8935H11.8935H11.8935H11.8935H11.8935H11.9201C11.9236 7.11095 11.9283 7.1109 11.9341 7.11085C12.0622 7.10962 12.7441 7.10311 13.3991 7.45376C14.2276 7.90383 14.6809 8.73612 14.7589 10.0635V10.0828V10.2374L14.7712 10.2435C14.7761 10.316 14.7815 10.4155 14.7848 10.5364C14.792 10.8057 14.7888 11.1792 14.7468 11.5955C14.6619 12.4384 14.4226 13.4116 13.8368 14.0706ZM14.8661 14.9726L14.8713 14.9674L14.8762 14.962C15.6714 14.0673 15.9869 12.8623 16.1058 11.8734C16.2237 10.893 16.1526 10.0893 16.137 9.9312C16.0525 8.23055 15.383 7.1424 14.5241 6.4919C13.6771 5.85048 12.67 5.65249 11.9201 5.67883C11.1702 5.65249 10.1631 5.85048 9.31615 6.4919C8.45721 7.1424 7.78776 8.23054 7.70327 9.93118C7.68769 10.089 7.61648 10.8863 7.73442 11.8635C7.85344 12.8497 8.16899 14.0533 8.96274 14.9605L8.96823 14.9668L8.97411 14.9726L8.97948 14.978C9.06263 15.0612 9.15075 15.1493 9.24135 15.2322C9.03114 15.58 8.3213 16.3712 6.03832 17.0664C4.86157 15.688 4.15533 13.9037 4.15533 11.9734C4.15533 7.63807 7.6647 4.1287 12 4.1287C16.3353 4.1287 19.8447 7.63807 19.8447 11.9734C19.8447 13.9559 19.1381 15.7169 17.9609 17.094C16.4045 16.6329 15.5767 16.128 15.1386 15.7375C14.8622 15.4912 14.7388 15.2888 14.6841 15.1664C14.6987 15.1516 14.7125 15.137 14.7257 15.1229C14.744 15.1032 14.7604 15.0852 14.7761 15.0681C14.8063 15.0351 14.8335 15.0053 14.8661 14.9726ZM12 2.75C6.90975 2.75 2.75 6.88216 2.75 12C2.75 17.0903 6.88216 21.25 12 21.25C17.0903 21.25 21.25 17.1178 21.25 12C21.25 6.90927 17.0907 2.75 12 2.75ZM12 19.8447C10.1726 19.8447 8.49815 19.2117 7.17691 18.1659C9.17151 17.4605 10.0515 16.6264 10.437 15.9682C10.8748 16.1358 11.3636 16.2175 11.8669 16.2175H11.8935H11.9201H11.9467H11.9734C12.5292 16.2175 13.0476 16.1139 13.5092 15.922C13.8792 16.5717 14.7549 17.442 16.8267 18.1684C15.5069 19.2315 13.8316 19.8447 12 19.8447Z" fill="currentColor" stroke="currentColor" stroke-width="0.1"/></svg>';

  export default {
    name: 'ModalInquiryConflict',
    components: {
      Select,
      Button,
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {
      warn: {
        type: Boolean,
        default: true,
      },
      versions: {
        type: Array,
        default: () => [],
      },
    },
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {
        psychologists: [],
        ivalue: null,
      };
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {
      actions() {
        const i18n = this.$i18n;
        return [
          { value: 'cancel', label: i18n.t('labels.cancel') },
          { value: 'resolve', label: i18n.t('labels.resolve') },
        ];
      },
      actionButtons() {
        const out = [];
        const actions = this.actions || [];
        const numActions = actions.length;
        actions.forEach((action, index) => {
          const btnData = {
            ...action,
          };
          if (!btnData.class) {
            btnData.class = (index + 1 < numActions) ? 'secondary' : 'primary';
          }
          out.push(btnData);
        });
        return out.length > 0 ? out : null;
      },
      computedVersions() {
        const localeOptions = {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false,
        };
        const psychologists = this.psychologists || [];
        return this.versions.map((v, idx) => {
          const timestr = new Date(v.modified * 1000).toLocaleString('de-CH', localeOptions);
          const text = v.local ? 'Lokal' : 'Cloud';
          const icon = v.local ? '💻' : '☁️';
          const type = v.local ? 'local' : 'cloud';
          const modifier = psychologists.find(o => o?.value === v?.modifier);
          let modstr = Store.name;
          if (modifier) {
            modstr = `${modifier.label}`;
          }
          return {
            label: `<span class="info"><span class="pill ${type}"><span>${icon}</span>${text}</span>${timestr} Uhr</span><span class="user">${modstr} ${svgIcon}</span>`,
            value: idx,
          };
        });
      },
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    // filters: {},
    //---------------------------------------------------
    //
    //  Validation Properties
    //
    //---------------------------------------------------
    // validations: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    async created() {
      const { options } = await InquiryDefinitionFunctions.getPsychologists();
      this.psychologists = options || [];
    },
    // beforeMount() {},
    // render(h) { return h(); },
    mounted() {
      this.ivalue = 0;
    },
    // beforeUpdate() {},
    // updated() {},
    beforeDestroy() {
      if (this.$el.parentNode) {
        this.$el.parentNode.removeChild(this.$el);
      }
    },
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      close() {
        this.$emit('close');
        this.$destroy();
      },
      //----------------------------------
      // Event Handlers
      //----------------------------------
      handleInput(index) {
        const { data, local } = this.versions[index];
        if (data) {
          this.$emit('change', { data, local });
        }
      },
      async handleActionClick(action) {
        if (action === 'cancel') {
          this.$emit('cancel');
        } else if (action === 'resolve') {
          const { data, local } = this.versions[this.ivalue];
          if (data) {
            this.$emit('resolve', { data, local });
          }
        }
        this.close();
      },
    },
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';

@keyframes warn {
  0% { opacity: 0; transform: scale(0.98); }
  50% { opacity: 1; transform: scale(1) }
  100% { opacity: 0; transform: scale(1.02) }
}

.conflict-modal {
  position: fixed;
  top: 12px;
  left: 50%;
  transform: translate(-50%, 0);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-self: center;
  background-color: $color-white-solid-10;
  border-radius: $default-border-radius;
  border: 2px solid $color-blue-solid-60;
  outline: 1px solid rgba(0, 0, 0, 0.1);
  min-width: 570px;
  max-width: calc(100vw - 40px);
  filter: drop-shadow(0px 2px 4px rgba(16, 0, 0, 0.4));
  padding: 16px;
  opacity: 1;
  z-index: 1000;

  &:before {
    content: '';
    position: absolute;
    top: -2px;
    left: -2px;
    border-radius: $default-border-radius;
    width: calc(100% + 4px);
    height: calc(100% + 4px);
    border: 2px solid #F0A718;
    box-shadow: 0 0 10px 5px #F0A718;
    opacity: 0;
    pointer-events: none;
  }

  &.warn:before {
    animation: warn 1.5s linear forwards;
    animation-iteration-count: 3;
  }

  & > .content {
    span.title {
      margin-top: 0;
      display: block;
      text-transform: uppercase;
      font-weight: bold;
    }

    p {
      font-size: 1.5rem;
      line-height: 1.5;
    }

    .input-select {
      span.label, ul > li > span {
        display: inline-flex;
        width: 100%;
        justify-content: space-between;
        align-items: center;
        & > span.info {
          & >  span.pill {
            position: relative;
            display: inline-block;
            font-size: 1rem;
            top: -1px;
            background-color: transparent;
            border: 1px solid $color-black-alpha-60;
            padding: 4px 10px 4px 8px;
            height: 18px;
            border-radius: 18px;
            line-height: 1;
            margin-right: 4px;
            font-weight: bold;

            & > span {
              display: inline-block;
              position: relative;
              top: 0;
              line-height: 0;
              margin-right: 4px;
              font-size: 1.8rem;
            }

            &.local {
              background-color: $color-blue-solid-100;
              border: 1px solid $color-blue-solid-100;
              color: $color-white-solid-10;

              & > span {
                top: 1px;
              }
            }

            &.cloud {
              background: linear-gradient(90deg, $color-blue-solid-60 -20%, transparent 60%);
              border: 1px solid $color-blue-solid-100;
              color: $color-blue-solid-100;

              & > span {
                top: 2px;
                filter: drop-shadow(0 0 1px $color-blue-solid-80);
              }
            }
          }
        }
        & > span.user {
          position: relative;
          display: inline-flex;
          align-items: center;
          font-size: 11px;

          &:after {
            content: '';
          }

          & > svg {
            inset: auto;
            display: inline-block;
            margin-left: 4px;
            position: relative;
            width: 16px;
            height: 16px;
            opacity: 0.5;
          }
        }
      }
      ul > li.selected > span {
        width: calc(100% - 23px);
      }
    }
  }

  & > .actions {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;

    button {
      margin-right: 16px;
      &.icon.only {
        min-width: auto;
      }
      &:last-of-type {
        margin-right: 0;
      }
    }
  }
}
</style>
